import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false
};


export default function edu_directions (state = initialState, action) {
  switch (action.type) {
    case types.SET_EDU_DIRECTIONS_LIST:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_EDU_DIRECTIONS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}